import SelectBox from "components/Common/SelectBox"
import Select from "react-select"
import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Table,
} from "reactstrap"
import DetailTable from "./DetailTable"
import SButton from "components/Common/Button"
import ProductListModal from "../ProductListModal"
import { IgarashiCustomerAPI } from "helpers/customer_backend_helper"
import {
  defaultPayload,
  defaultProductTableData,
  productTableItem,
} from "../default-values"
import {
  createRetailListApi,
  getRetailListPaymentApi,
} from "helpers/retail_list_helper"
import { defaultSelect } from "pages/CorporateOrders/default-values"
import { useHistory } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DateInput from "components/Common/DateInput"
import BackButton from "components/Common/BackButton"
import moment from "moment"

export default function Index() {
  const history = useHistory()
  const [productModalShown, setProductModalShown] = useState(false)

  // payload
  const [payload, setPayload] = useState(defaultPayload)
  const [payments, setPayments] = useState([])

  // select options
  const [paymentOptions, setPaymentOptions] = useState(null)

  console.log("paymentOptions")
  console.log(paymentOptions)

  // select value
  const [payment, setPayment] = useState(defaultSelect)

  // inputs  and selects
  const [productTableData, setProductTableData] = useState(
    defaultProductTableData
  )
  const [productIndex, setProductIndex] = useState(null)

  const [customers, setCustomers] = useState([])
  const [customer, setCustomer] = useState({ label: "", value: "" })
  const [customerName, setCustomerName] = useState("")
  const [isGuest, setIsGuest] = useState(false)
  const [orderDate, setOrderDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  )

  const [paymentDate, setPaymentDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  )
  const [paymentMethodId, setPaymentMethodId] = useState(0)
  const [paymentMethodName, setPaymentMethodName] = useState("")
  const [amount, setAmount] = useState(0)

  console.log("orderDate")
  console.log(orderDate)
  const loadCustomers = async () => {
    try {
      const { data } = await IgarashiCustomerAPI.getList()
      if (data.length) {
        const _customers = data.map(item => ({
          value: item.id,
          label: `${item.customerName}`,
          org: item,
        }))

        setCustomers(_customers)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const loadPaymentMethods = async () => {
    try {
      const { data } = await getRetailListPaymentApi()
      const _paymentMethods = data.map(item => ({
        label: item.name,
        value: item.id,
      }))
      setPaymentOptions(_paymentMethods)
    } catch (error) {
      console.log(error)
    }
  }

  const calculatePayloadDiscount = (product, price, inputDiscount) => {
    const { discountType, number } = product
    const _product = { ...product }
    if (!number)
      return {
        ...product,
        amount: 0,
      }
    if (!inputDiscount) {
      return {
        ...product,
        amount: number * price,
        discount: 0,
      }
    }
    let _discount = 0
    if (discountType === "%") {
      _discount = price * number * inputDiscount * 0.01
    } else {
      _discount = inputDiscount
    }
    _product.amount = price * number - _discount
    _product.discount = _discount
    return _product
  }

  const calculateTableDiscount = product => {
    const { number, unitPrice, discountType, inputDiscount } = product
    const _product = { ...product }

    if (!number) {
      return {
        ...product,
        totalAmount: 0,
      }
    }

    if (!inputDiscount) {
      return {
        ..._product,
        totalAmount: number * unitPrice,
        discount: 0,
      }
    }

    let _discount = 0
    if (discountType === "%")
      _discount = unitPrice * number * inputDiscount * 0.01
    else _discount = inputDiscount

    _product.totalAmount = unitPrice * number - _discount
    _product.discount = _discount
    return _product
  }

  const stateHandlers = {
    guest: bool => setIsGuest(bool),
    customerId: obj => setCustomer(obj),
  }

  const handleInput = obj => {
    const _payload = { ...payload }
    switch (obj.type) {
      case "guest": {
        const {
          e: {
            target: { checked },
          },
        } = obj
        stateHandlers[obj.type](checked)
        _payload[obj.type] = checked
        break
      }

      case "orderDate": {
        _payload[obj.type] = moment(obj).format("YYYY-MM-DD")
        break
      }

      case "customerId": {
        const { val, type } = obj
        stateHandlers[type](val)
        _payload[obj.type] = val.value
        _payload.customerName = val.org.customerName
        break
      }

      case "number": {
        const {
          e: {
            target: { value },
          },
          type,
          idx,
        } = obj

        const _productTableData = [...productTableData]
        const _productItem = { ...productTableData[idx] }
        const _totalAmount =
          +value * _productItem.unitPrice - _productItem.discount
        _productItem.totalAmount = _totalAmount
        _productItem.number = +value
        const productAfterDiscount = calculateTableDiscount(_productItem)
        _productTableData[idx] = productAfterDiscount
        setProductTableData(_productTableData)

        const _details = [...payload.details]
        const _detail = { ...payload.details[idx] }
        _detail.number = +value
        const _detailAfterDiscount = calculatePayloadDiscount(
          _detail,
          _productItem.unitPrice,
          _productItem.inputDiscount
        )

        _details[idx] = _detailAfterDiscount
        _payload.details = _details
        break
      }
      // ? discount note, percentage is no problem,
      // what about fixed amount?
      // is it applied to every single item, or to the grand total?
      case "discountType": {
        const {
          type,
          idx,
          e: {
            target: { value },
          },
        } = obj
        const _productTableData = [...productTableData]
        const _productItem = { ...productTableData[idx] }

        _productItem[type] = value
        const productAfterDiscount = calculateTableDiscount(_productItem)
        _productTableData[idx] = productAfterDiscount
        setProductTableData(_productTableData)

        const _details = [...payload.details]
        const _detail = { ...payload.details[idx] }
        _detail[type] = value
        const _detailAfterDiscount = calculatePayloadDiscount(
          _detail,
          _productItem.unitPrice,
          _productItem.inputDiscount
        )
        _details[idx] = _detailAfterDiscount
        _payload.details = _details
        break
      }

      case "discountAmount": {
        const {
          idx,
          e: {
            target: { value },
          },
        } = obj
        const _productTableData = [...productTableData]
        const _productItem = { ...productTableData[idx] }

        _productItem.inputDiscount = +value
        const productAfterDiscount = calculateTableDiscount(_productItem)
        _productTableData[idx] = productAfterDiscount
        setProductTableData(_productTableData)

        const _details = [...payload.details]
        const _detail = { ...payload.details[idx] }

        const _detailAfterDiscount = calculatePayloadDiscount(
          _detail,
          _productItem.unitPrice,
          _productItem.inputDiscount
        )
        _details[idx] = _detailAfterDiscount
        _payload.details = _details

        break
      }

      // for the following three, we don't do anything with payload
      // just need to store them temporarily;
      case "paymentDate": {
        setPaymentDate(moment(obj.e).format("YYYY-MM-DD"))
        break
      }

      case "paymentMethodId": {
        const { val } = obj
        setPayment(val)
        setPaymentMethodId(val?.value)
        setPaymentMethodName(val?.label)
        break
      }

      case "amount": {
        const {
          e: {
            target: { value },
          },
        } = obj
        setAmount(+value)
        break
      }
    }
    setPayload(_payload)
  }

  const handleModalShow = idx => {
    setProductIndex(+idx)
    setProductModalShown(true)
  }

  const handleProductAdd = product => {
    const { number, productName, unitPrice, size, productId } = product
    /**
     * ui
     * productNumber
     * productName
     * unitPrice
     */
    const _details = [...payload.details]
    const _detail = {
      productId,
      size,
      number: 0,
      discountType: "%",
      amount: 0,
      discount: 0,
    }

    _details[productIndex] = _detail

    // payload
    const _payload = { ...payload, details: _details }
    const _productTableData = [...productTableData]
    const _productItem = { ...productTableData[productIndex] }

    _productItem.productNumber = number
    _productItem.productName = productName
    _productItem.unitPrice = unitPrice
    _productTableData[productIndex] = _productItem
    // note: check also if all fields are filled after this addition;

    // if so push a new item at the end of the array
    const emptyProduct = _productTableData.filter(
      data => !data.productNumber
    ).length

    if (!emptyProduct) _productTableData.push(productTableItem)

    setPayload(_payload)
    setProductTableData(_productTableData)
    setProductModalShown(false)
  }

  const addPayment = () => {
    if (!paymentMethodId || !amount || !paymentDate) {
      return
    }

    // add new elements to payments
    const _payload = { ...payload }
    const _payments = [...payments]
    const _payment = {
      paymentDate: moment(paymentDate).format("YYYY-MM-DD"),
      paymentMethodId,
      amount,
      paymentMethodName,
    }

    if (isEdit) {
      Object.assign(_payments[unitPricesIndex], _payment)
    } else {
      _payments.push(_payment)
    }

    _payload.payments = _payments

    // update the state
    setPayments(_payments)
    setPayload(_payload)

    setPaymentDate(null)
    setPayment(defaultSelect)
    setAmount("")
    setUnitPricesIndex(null)
    setIsEdit(false)
    setModal(!modal)
  }

  const validate = obj => {
    // todo: we might need more to validate here,
    // eg: check if quantity of each product must be at least one

    const { guest, customerName: cne, customerId: cid, details: d } = obj
    return !((!guest && !cne) || (guest && !cid) || !d.length)
  }

  const handleSubmit = async () => {
    const _payload = {
      ...payload,
      customerName: customerName,
      details: payload.details.filter(detail => detail.productId),
    }
    // if (!validate(_payload)) return

    try {
      const res = await createRetailListApi(_payload)
      if (res.status === 200) history.push("/retail-list")
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    loadCustomers()
    loadPaymentMethods()
  }, [])

  const config = {
    productModalShown,
    setProductModalShown,
    payload,
    setPayload,
    payments,
    setPayments,
    productTableData,
    setProductTableData,
    customers,
    setCustomers,
    customer,
    setCustomer,
    customerName,
    setCustomerName,
    isGuest,
    setIsGuest,
    orderDate,
    setOrderDate,
    handleProductAdd,
    handleModalShow,
    handleInput,
  }

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [unitPricesIndex, setUnitPricesIndex] = useState(null)

  const toggle = () => setModal(!modal)

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="新規RTW小売" breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col sm={3}>
                <FormGroup row>
                  <Label sm={3} htmlFor="customerName">
                    顧客名
                  </Label>
                  <Col sm={9}>
                    {isGuest ? (
                      <Input
                        type="text"
                        name="customerName"
                        value={customerName}
                        onChange={e => setCustomerName(e.target.value)}
                      />
                    ) : (
                      <SelectBox
                        options={customers}
                        value={customer}
                        onChange={val =>
                          handleInput({ val, type: "customerId" })
                        }
                      />
                    )}
                  </Col>
                </FormGroup>
              </Col>
              <Col sm={1} className="d-flex align-items-center">
                <Input
                  type="checkbox"
                  style={{ marginBottom: "19px" }}
                  id="guest"
                  onChange={e => handleInput({ e, type: "guest" })}
                  defaultChecked={isGuest}
                />
                <Label
                  className="ms-2"
                  htmlFor="guest"
                  style={{ marginBottom: "17px" }}
                >
                  ゲスト
                </Label>
              </Col>
              <Col sm={3}>
                <FormGroup row>
                  <Label sm={3}>受注日</Label>
                  <Col sm={9}>
                    <DateInput
                      value={orderDate}
                      onChange={([e]) => {
                        handleInput({ e, type: "orderDate" })
                        setOrderDate(moment(e).format("YYYY-MM-DD"))
                      }}
                      className="form-control"
                    />
                  </Col>
                </FormGroup>
              </Col>

              <Col sm={5}>
                {/* button submit */}
                <div className="d-flex align-items-center justify-content-end">
                  <SButton className="button" onClick={handleSubmit}>
                    保存
                  </SButton>
                  <BackButton className="ms-2 button" />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Row className="mt-4">
          <Col sm={12}>
            <Card>
              <CardBody>
                <DetailTable config={config} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Col sm={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col className="d-flex justify-content-end mb-2 " md={12}>
                      <SButton onClick={toggle} className="button">
                        登録
                      </SButton>
                    </Col>
                  </Row>

                  <Table bordered className="mt-2">
                    <thead>
                      <tr className="text-center">
                        <th>日付</th>
                        <th>入金方法</th>
                        <th>金額</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {payments.length
                        ? payments.map((payment, idx) => (
                            <tr key={idx}>
                              <td>{payment.paymentDate}</td>
                              <td>{payment.paymentMethodName}</td>
                              <td>{payment.amount.toLocaleString("ja-JP")}</td>
                              <td>
                                <SButton
                                  onClick={() => {
                                    setUnitPricesIndex(idx)
                                    setPaymentDate(payment.paymentDate)
                                    setAmount(payment.amount)
                                    setPayment({
                                      value: payment.paymentMethodId,
                                      label: payment.paymentMethodName,
                                    })
                                    setPaymentMethodId(payment.paymentMethodId)
                                    setPaymentMethodName(
                                      payment.paymentMethodName
                                    )
                                    setIsEdit(true)
                                    toggle()
                                  }}
                                  size="sm"
                                  className="button"
                                >
                                  編集
                                </SButton>
                              </td>
                            </tr>
                          ))
                        : ""}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Col>
        </Row>

        <Modal isOpen={modal} toggle={toggle}>
          <ModalBody>
            <FormGroup row>
              <Label sm={2} htmlFor="paymentDate">
                日付
              </Label>
              <Col sm={10}>
                <DateInput
                  value={paymentDate}
                  className="form-control"
                  onChange={([e]) => {
                    handleInput({ e, type: "paymentDate" })
                    setPaymentDate(e)
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label htmlFor="paymentMethodId" sm={2}>
                入金方法
              </Label>
              <Col sm={10}>
                <Select
                  options={paymentOptions}
                  value={payment}
                  isClearable
                  onChange={val =>
                    handleInput({ val, type: "paymentMethodId" })
                  }
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label htmlFor="amount" sm={2}>
                代金回収
              </Label>
              <Col sm={10}>
                <input
                  className="form-control"
                  id="amount"
                  type="number"
                  value={amount}
                  min={0}
                  onChange={e => handleInput({ e, type: "amount" })}
                />
              </Col>
            </FormGroup>
            <Row>
              <Col sm={12} className="d-flex justify-content-end">
                <SButton className="button" onClick={addPayment}>
                  登録
                </SButton>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
        <ProductListModal config={config} />
      </Container>
    </div>
  )
}
